import { render, staticRenderFns } from "./ReceiveAccounts.vue?vue&type=template&id=13f9ce2f&"
import script from "./ReceiveAccounts.vue?vue&type=script&lang=ts&"
export * from "./ReceiveAccounts.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports